import { render, staticRenderFns } from "./ExamCoordinator.vue?vue&type=template&id=390c4134&scoped=true"
import script from "./ExamCoordinator.vue?vue&type=script&lang=js"
export * from "./ExamCoordinator.vue?vue&type=script&lang=js"
import style0 from "./ExamCoordinator.vue?vue&type=style&index=0&id=390c4134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390c4134",
  null
  
)

export default component.exports